import { t } from "i18next";
import Cookies from "js-cookie";
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { LANGuAGE_COOKIE } from "src/resources/constant";
import { isRtl, toCamel } from "src/utils/helpers";

interface TextConfig {
  text: string;
  fontSize: number;
  fontWeight: string;
  xOffset: number;
  yOffset: number;
}

interface IconConfig {
  src: string;
  xOffset: number;
  yOffset: number;
  size: number;
}
interface DoughnutChartProps {
  chartData: any;
  options: any;
  centerText?: TextConfig[];
  iconObj?: IconConfig;
}

function DoughnutChart({
  chartData,
  options,
  centerText,
  iconObj,
}: DoughnutChartProps) {
  const [localCenterText, setLocalCenterText] = useState<
    TextConfig[] | undefined
  >(centerText);
  const [text1Config, setText1Config] = useState<TextConfig | undefined>(
    localCenterText && localCenterText[0]
  );
  const [text2Config, setText2Config] = useState<TextConfig | undefined>(
    localCenterText && localCenterText[1]
  );

  const iconConfig = iconObj;
  const icon = new Image();
  icon.src = iconConfig ? iconConfig.src : "src/assets/icons/noun-building.svg";

  const centerTextPlugin = {
    id: "centerText",
    afterDraw(chart: { chartArea?: any; ctx?: any }) {
      const { ctx } = chart;
      ctx.save();
      const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
      const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#000";

      if (text1Config) {
        ctx.font = `${text1Config.fontWeight}  ${text1Config.fontSize}px Gilroy`;
        // Draw text1
        ctx.fillText(
          text1Config.text,
          centerX + text1Config.xOffset,
          centerY + text1Config.yOffset
        );
      }
      // Draw text2 if provided
      if (text2Config) {
        const key = _.lowerFirst(text2Config.text.toString());
        const text = t(key);
        ctx.font = `${text2Config.fontWeight} ${text2Config.fontSize}px Gilroy`;
        ctx.fillText(
          text,
          centerX + text2Config.xOffset,
          centerY + text2Config.yOffset
        );
      }

      // Draw icon if provided
      if (iconConfig) {
        ctx.drawImage(
          icon,
          centerX + iconConfig.xOffset - iconConfig.size / 2,
          centerY + iconConfig.yOffset - iconConfig.size / 2,
          iconConfig.size,
          iconConfig.size
        );
      }

      ctx.restore();
    },
  };

  useEffect(() => {}, [localCenterText, iconConfig, text2Config, text1Config]);
  const newChartData = _.cloneDeep(chartData);
  if (isRtl(Cookies.get(LANGuAGE_COOKIE))) {
    newChartData.labels = _.reverse(newChartData.labels);
    newChartData.datasets[0].data = _.reverse(newChartData.datasets[0].data);
    newChartData.datasets[0].backgroundColor = _.reverse(
      newChartData.datasets[0].backgroundColor
    );
  }
  return (
    <>
      {newChartData && (
        <Doughnut
          data={newChartData}
          options={options}
          plugins={[centerTextPlugin]} // Include the plugin here
        />
      )}
    </>
  );
}

export default DoughnutChart;
